// extracted by mini-css-extract-plugin
module.exports = {"workouts":"WorkoutsGrid_workouts__2L_Ob","filtered":"WorkoutsGrid_filtered__Gzxm1","heading":"WorkoutsGrid_heading__2YuK_"};